module.exports = __webpack_public_path__ + "img/ic_validity.c54906f.svg";